'use client';

import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AuthMutation } from '@/api';

interface UseDeleteCommentMutationOptions {
  onDeleteSuccess?: () => void | Promise<void>;
}

// 댓글 삭제 후 관련 목록 캐시를 정리하는 공통 훅이다.
export const useDeleteCommentMutation = (
  options?: UseDeleteCommentMutationOptions,
) => {
  const { toast, toastError } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    ...AuthMutation[
      'put:/wello/v2/auth/wello-comment/{welloCommentId}/delete'
    ](),
    onError: (error) => {
      toastError({ error });
    },
    onSuccess: async () => {
      try {
        // 목록 재조회 전 composer 상태를 먼저 정리해야 삭제된 댓글 수정 UI가 남지 않는다.
        await options?.onDeleteSuccess?.();
      } finally {
        toast({ type: 'success', message: '댓글이 삭제되었습니다.' });
        // 삭제 후에도 작성/수정과 동일하게 전체 캐시 기준으로 동기화한다.
        await queryClient.invalidateQueries();
      }
    },
  });
};
